import React from 'react';
import classnames from 'classnames';
import {Link} from 'react-router';

export default function FormField(props) {

    const {
        className = '',
        children = [],
        after = null,
        horizontal = false,
        label = null,
        name = null,
        field = null,
        helperText = null,
        link=null,
        dots=true
    } = props;

    const error = field.touched && field.error
    return (
        <div className={classnames('form-field', name && `form-field-${name}`, className, {error, horizontal})}>
            {label && <label> {link ? <Link to={link} target="_blank">{label}</Link> : `${label}${dots?':':''}`}</label>}
            <div className="field-control">
                {children}
            </div>
            {after}
            {error && <div className="error-msg">{error}</div>}
            {helperText && <div className="helper-text">{helperText}</div>}
        </div>
    );
}



// WEBPACK FOOTER //
// ./src/js/components/form/form-field.js